export default __webpack_public_path__ + "static/media/category_a.bc19e831.svg";